<template>
  <div class="user-wrapper">
    <div class="content_box">
      <p>欢迎你，<span>{{ nickname }}</span> 老师!</p>
      <!-- <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <a-avatar class="avatar" size="small" :src="avatar"/>
          <span>{{ nickname }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <a-menu-item key="0">
            <router-link :to="{ name: 'center' }">
              <a-icon type="user"/>
              <span>个人中心</span>
            </router-link>
          </a-menu-item>
          <a-menu-item key="1">
            <router-link :to="{ name: 'settings' }">
              <a-icon type="setting"/>
              <span>账户设置</span>
            </router-link>
          </a-menu-item>
          <a-menu-divider/>
          <a-menu-item key="3">
            <a href="javascript:;" @click="handleLogout">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserMenu',
  components: {

  },
  data(){
    return {
        avatar:require('@/assets/icons/avatar-default.png'),
        nickname:'张大大'
    }
  },
  computed: {

  },
  mounted(){
    this.nickname = this.appUtils.getUserName();
  },
  methods: {
    handleLogout () {
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk: () => {
            this.appUtils.removeLocalStorage(this.constStatic.TOKEN_KEY);
            this.appUtils.removeLocalStorage(this.constStatic.USER_INFO);
            this.appUtils.removeLocalStorage(this.constStatic.JTI);
            this.$router.replace('/login');
        },
        onCancel () {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .content_box{
    p{
      color: #999;
      span{
        color: #333;
      }
    }
  }
</style>
